"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "roles-page-top-button-wrapper" };
const _hoisted_2 = { class: "d-flex flex-gap" };
const _hoisted_3 = { class: "page-title-text d-flex c-hand" };
const _hoisted_4 = {
    key: 0,
    href: "https://x.gd/u1xzU",
    target: "_blank",
    class: "circle-question"
};
const _hoisted_5 = {
    key: 0,
    class: "d-flex"
};
const _hoisted_6 = { class: "d-flex flex-gap flex-wrap align-self-end" };
const _hoisted_7 = { class: "role-section-content" };
const _hoisted_8 = {
    key: 0,
    class: "role-section-component"
};
const RoleCreateButton_vue_1 = __importDefault(require("../../vue/components/RoleCreateButton.vue"));
const EmptyContent_vue_1 = __importDefault(require("../../vue/components/EmptyContent.vue"));
const RoleSectionTable_vue_1 = __importDefault(require("./RoleSectionTable.vue"));
const RoleSectionSubContent_vue_1 = __importDefault(require("./RoleSectionSubContent.vue"));
const BreadCrumbArrowIcon_vue_1 = __importDefault(require("../../assets/icons/BreadCrumbArrowIcon.vue"));
const vue_3 = require("vue");
const role_requests_1 = require("../../js/role_requests");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const roles_js_1 = require("../../js/roles.js");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionContent',
    props: {
        roleStore: {
            type: Object,
            required: true,
        },
        meStore: {
            type: Object,
            required: true,
        }
    },
    setup(__props) {
        const { addRoleSection, deleteRoleSection } = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewInjectionKey, { addRoleSection: () => { }, deleteRoleSection: () => { } });
        const roleSectionID = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleSectionIDInjectionKey, "");
        const props = __props;
        const roleSectionArray = (0, vue_3.computed)(() => props.roleStore.query({ filterRoleSection: true, isRoleSection: true }));
        (0, vue_3.provide)(roleSectionInjectionKeys_1.RoleSectionArray, roleSectionArray);
        // Local data
        const data = (0, vue_3.ref)({
            isRoleSectionFormActive: false,
            isRoleSectionTableLoading: false,
            isFormLoading: false,
            selectedRole: undefined
        });
        // Computed
        const hasRoleSections = (0, vue_3.computed)(() => {
            return roleSectionArray.value.length > 0;
        });
        const selectedRoleObject = (0, vue_3.computed)(() => {
            return data.value.selectedRole;
        });
        const hasSelectedRole = (0, vue_3.computed)(() => {
            return selectedRoleObject.value != null;
        });
        const roleSectionTextColor = (0, vue_3.computed)(() => {
            return {
                color: selectedRoleObject.value?.color ? `#${selectedRoleObject.value.color}` : "#8a8a8a"
            };
        });
        // Methods
        function handleCreateButtonClick() {
            data.value.selectedRole = undefined;
            data.value.isRoleSectionFormActive = !data.value.isRoleSectionFormActive;
        }
        function handleRoleCreateEmit() {
            data.value.isRoleSectionFormActive = !data.value.isRoleSectionFormActive;
            if (!data.value.isRoleSectionFormActive) {
                data.value.selectedRole = undefined;
                //pushState or replaceState may not be available to certain browsers
                if (window.history.pushState) {
                    window.history.pushState({}, "", `/dashboard/${props.meStore.getActiveUserId()}/roles?role-section-page=true&c=${props.meStore.getActiveBranchId()}`);
                }
                else if (window.history.replaceState) {
                    window.history.replaceState({}, "", `/dashboard/${props.meStore.getActiveUserId()}/roles?role-section-page=true&c=${props.meStore.getActiveBranchId()}`);
                }
            }
        }
        function handleRoleUpdate(roleId) {
            //pushState or replaceState may not be available to certain browsers
            if (window.history.pushState) {
                window.history.pushState({}, "", `/dashboard/${props.meStore.getActiveUserId()}/roles?role-section-page=true&c=${props.meStore.getActiveBranchId()}&r=${roleId}`);
            }
            else if (window.history.replaceState) {
                window.history.replaceState({}, "", `/dashboard/${props.meStore.getActiveUserId()}/roles?role-section-page=true&c=${props.meStore.getActiveBranchId()}&r=${roleId}`);
            }
            data.value.selectedRole = props.roleStore.byId(roleId);
            data.value.isRoleSectionFormActive = true;
        }
        // Delete
        async function handleRoleSectionDelete(roleId) {
            try {
                data.value.isRoleSectionTableLoading = true;
                const response = await (0, role_requests_1.deleteRoleRequest)(roleId);
                if (response.success) {
                    return deleteRoleSection(roleId);
                }
            }
            catch (err) {
                (0, roles_js_1.openAlertModal)("fail to delete role section");
            }
            finally {
                data.value.isRoleSectionTableLoading = false;
            }
        }
        (0, vue_3.onBeforeMount)(() => {
            if (roleSectionID && props.roleStore.byId(roleSectionID)) {
                handleRoleUpdate(roleSectionID);
            }
        });
        (0, vue_3.provide)(roleSectionInjectionKeys_1.RoleSectionArray, roleSectionArray);
        (0, vue_3.provide)(roleSectionInjectionKeys_1.RoleViewSelectedRole, selectedRoleObject);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("span", _hoisted_3, [
                            (0, vue_2.createElementVNode)("span", { onClick: handleCreateButtonClick }, [
                                (0, vue_2.createTextVNode)("業務セクション "),
                                (!hasSelectedRole.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", _hoisted_4))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ]),
                            (0, vue_2.createVNode)(vue_2.Transition, { name: "slide-right" }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (hasSelectedRole.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                            (0, vue_2.createVNode)(BreadCrumbArrowIcon_vue_1.default, { class: "breadcrumb-arrow" }),
                                            (selectedRoleObject.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                    key: 0,
                                                    style: (0, vue_2.normalizeStyle)(roleSectionTextColor.value)
                                                }, (0, vue_2.toDisplayString)(selectedRoleObject.value.getName()), 5 /* TEXT, STYLE */))
                                                : (0, vue_2.createCommentVNode)("v-if", true)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createVNode)(RoleCreateButton_vue_1.default, {
                            "is-active": data.value.isRoleSectionFormActive,
                            onOpenCreateModal: handleRoleCreateEmit
                        }, null, 8 /* PROPS */, ["is-active"])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "slide-fade" }, {
                        default: (0, vue_2.withCtx)(() => [
                            (!data.value.isRoleSectionFormActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                    (hasRoleSections.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleSectionTable_vue_1.default, {
                                            key: 0,
                                            "is-loading": data.value.isRoleSectionTableLoading,
                                            onRoleSectionOnDelete: handleRoleSectionDelete,
                                            onRoleSectionOnEdit: handleRoleUpdate
                                        }, null, 8 /* PROPS */, ["is-loading"]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(EmptyContent_vue_1.default, {
                                            key: 1,
                                            title: '業務セクションがありません',
                                            "sub-title": '上の作成ボタンから業務を作成してください。'
                                        }))
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleSectionSubContent_vue_1.default, {
                                    key: 1,
                                    class: "role-section-component",
                                    onUpdatedSelectedRole: handleRoleUpdate,
                                    "role-store": props.roleStore
                                }, null, 8 /* PROPS */, ["role-store"]))
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
